import React from 'react'
import {Svg, CommonSvgProps, commonPropTypes, commonDefaultProps} from '@modifi/ui'

type BFIconProps = CommonSvgProps

const BFIcon: React.FC<BFIconProps> = React.forwardRef<SVGSVGElement, BFIconProps>((props, ref) => (
  <Svg viewBox="0 0 33 33" {...props} ref={ref} color="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.172 4.12a3.024 3.024 0 0 1 3.023 0l8.96 5.765a.653.653 0 0 1-.655 1.13l-8.959-5.764a1.719 1.719 0 0 0-1.717 0l-.003.002-8.296 4.74-.001.001a1.718 1.718 0 0 0-.858 1.485v9.483a1.718 1.718 0 0 0 .858 1.485l.001.001 8.299 4.742c.26.15.557.23.859.23.36 0 .653.293.653.653 0 .361-.275.747-.635.747-.53 0-1.07-.233-1.53-.498L6.873 23.58l-.002-.002a3.024 3.024 0 0 1-1.512-2.616v-9.485a3.024 3.024 0 0 1 1.512-2.616l.002-.001 8.296-4.74.002-.002Z"
      fill="#51565C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.768 9.918a.653.653 0 0 1 .892-.238l10.026 5.8 9.474-5.37a.653.653 0 1 1 .644 1.137l-9.8 5.553a.653.653 0 0 1-.648-.002L6.006 10.81a.653.653 0 0 1-.238-.893Z"
      fill="#51565C"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.682 15.568c.361 0 .654.292.654.653v11.95a.653.653 0 1 1-1.307 0V16.22c0-.36.293-.653.653-.653ZM26.866 9.858c.36 0 .653.293.653.653v11.95a.653.653 0 1 1-1.306 0v-11.95c0-.36.292-.653.653-.653Z"
      fill="#51565C"
    />
    <path
      d="M27.697 10.65a.75.75 0 0 0-1.5 0h1.5Zm-1.28 13.698a.75.75 0 0 0 1.06 0l4.773-4.773a.75.75 0 0 0-1.06-1.06l-4.243 4.242-4.243-4.243a.75.75 0 0 0-1.06 1.06l4.773 4.774Zm-.22-13.698v13.167h1.5V10.65h-1.5Z"
      fill="#7BB835"
    />
  </Svg>
))

BFIcon.propTypes = commonPropTypes
BFIcon.defaultProps = commonDefaultProps

export default BFIcon
